import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import { useCurrentUser } from "@/hooks/useCurrentUser";

export interface Profile {
  id: string;
  email: string | null;
  full_name: string | null;
  company: string | null;
  role: string;
  avatar_url: string | null;
  created_at: string;
}

interface UseProfileResult {
  profile: Profile | null;
  loading: boolean;
  error: string | null;
  reload: () => void;
}

export function useProfile(): UseProfileResult {
  const { user, loading: authLoading } = useCurrentUser();
  const [profile, setProfile] = useState<Profile | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    if (!user) {
      setProfile(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const { data, error: queryError } = await supabase
        .from("profiles")
        .select("*")
        .eq("id", user.id)
        .maybeSingle();
      if (queryError) throw queryError;
      setProfile((data as Profile) ?? null);
    } catch (err) {
      setError(err instanceof Error ? err.message : "资料加载失败");
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    void load();
  }, [load]);

  return { profile, loading: loading || authLoading, error, reload: load };
}